export default __webpack_public_path__ + "static/media/rps.23ee11df.png";